import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {formatToDollar, runAfterLoadSession, summarizeString} from "../../utils/Utility";
import {getListTaskStudent, getListTaskTutor} from "../../utils/API";
import HeaderApp from "../home/HeaderApp";
import {NavLink} from "react-router-dom";
import KeyVal from "../shared/KeyVal";
import {educationLevels} from "../register/Register";

class Tasks extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tasks: [],

        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            if (this.props.tutorEnv)
                getListTaskTutor((res) => {
                    this.setState({tasks: res})
                })
            else
                getListTaskStudent((res) => {
                    this.setState({tasks: res})
                })
        })

    }

    getStatus = (status, isBangladesh) => {
        if (status === 'SEARCHING')
            return ['Searching', '#ffab4f']
        else if (status === 'ACCEPT_BY_TUTOR')
            return [isBangladesh ? 'Accepted by tutor, please pay the task fee' : 'Accepted by tutor, please wait for payment confirmation', '#ffab4f']
        else if (status === 'PAYMENT_SUCCESS_AND_DOING')
            return ['Tutor is working on the task', '#4ea047']
        else if (status === 'PAYMENT_UNSUCCESSFUL')
            return ['Payment was unsuccessful, please check entered card information', '#cb0c19']
        else if (status === 'FINISH_TUTOR')
            return ['Marked as completed by the tutor', '#3e97c7']
        else if (status === 'FINISH_STUDENT')
            return ['Marked as completed by you', '#3e97c7']
        else if (status === 'CANCEL_BY_STUDENT')
            return ['Cancelled by you', '#cb0c19']
        else if (status === 'CANCEL_BY_TUTOR')
            return ['Cancelled by tutor', '#cb0c19']
        else if (status === 'NOT_FINDING_TUTOR')
            return ['Did not find any tutors. You can try again', '#ffab4f']
        else
            return ['Unknown', '#000']
    }

    getStatusTutor = (status) => {
        if (status === 'SEARCHING')
            return ['Unknown', '#ffab4f']
        else if (status === 'ACCEPT_BY_TUTOR')
            return ['You accepted the request, please wait for the student to pay the task fee', '#ffab4f']
        else if (status === 'PAYMENT_SUCCESS_AND_DOING')
            return ['The student has made a payment, you can start working on the task', '#4ea047']
        else if (status === 'PAYMENT_UNSUCCESSFUL')
            return ['Payment was unsuccessful, please wait for the student to pay the task fee', '#cb0c19']
        else if (status === 'FINISH_TUTOR')
            return ['You have requested to mark the task as compeleted, please wait for the student confirm', '#3e97c7']
        else if (status === 'FINISH_STUDENT')
            return ['Task is completed', '#3e97c7']
        else if (status === 'CANCEL_BY_STUDENT')
            return ['Task is cancelled by the student', '#cb0c19']
        else if (status === 'CANCEL_BY_TUTOR')
            return ['Task is cancelled by you', '#cb0c19']
        else if (status === 'NOT_FINDING_TUTOR')
            return ['Unknown', '#ffab4f']
        else
            return ['Unknown', '#000']
    }


    getOtherUser = (task) => {
        return this.props.tutorEnv ? task.student : task.tutor
    }

    isTutor = () => {
        return this.props.tutorEnv
    }

    render() {
        return (
            <div className="">
                <HeaderApp name="Tasks" back="/hom"/>
                <div className="main-app">
                    <div>
                        <div className="mt-3 body-app">
                            <div>
                                {this.state.tasks.length === 0 &&
                                <span className="d-block text-center mb-4">You don't have any tasks yet</span>}
                                {
                                    this.state.tasks.map((task) =>
                                        <div key={task.hashId}
                                             className="shadow-black mb-3 p-3">
                                            <div className="text-center">
                                                <h5>{task.title}</h5>
                                            </div>
                                            <div className="text-center mt-2 mb-1">
                                            <span className="bold"
                                                  style={{color: this.isTutor() ? this.getStatusTutor(task.status)[1] : this.getStatus(task.status)[1]}}>{this.isTutor() ? this.getStatusTutor(task.status)[0] : this.getStatus(task.status)[0]}</span>
                                            </div>

                                            <div className="d-flex flex-column">
                                                <KeyVal name="Field:" value={task.field.name}/>
                                                <KeyVal name="Category:" value={task.category.name}/>
                                                <KeyVal name="Due:"
                                                        value={new Date(task.deadline).toLocaleDateString("en-US")}/>
                                                <KeyVal name="Amount:" value={formatToDollar(this.isTutor() ? task.initialAmount : task.totalAmount)}/>
                                            </div>
                                            <div>
                                                <div className="border-bottom mb-2 pt-2"/>
                                                <div className="text-center">
                                                    <h5>{this.isTutor() ? 'Student' : 'Tutor'}</h5>
                                                </div>
                                                <div className="d-flex flex-row">
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <img alt="" className="img-circle"
                                                             src={window.baseFile + this.getOtherUser(task).profilePhotoUrl}/>
                                                    </div>
                                                    <div
                                                        className="d-flex pl-2 w-100 flex-row justify-content-between align-items-center">
                                                        <span>{this.getOtherUser(task).username}</span>
                                                        <span
                                                            className="grey-text">{educationLevels[this.getOtherUser(task).educationLevelOrdinal].title}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <div>
                                                    <NavLink
                                                        to={'/hom/chat/' + this.props.profile.hashId + "/" + this.getOtherUser(task).hashId}
                                                        className="waves-effect waves-light btn white no-uppercase shadow-black ml-3">
                                                        <span
                                                            className="black-text">Chat to {this.isTutor() ? 'student' : 'tutor'}</span>
                                                    </NavLink>
                                                </div>
                                                {task.files !== '' && <div>
                                                    <div className="border-bottom mt-2 mb-2 pb-2"/>
                                                    <div><span
                                                        className="bold">File uploaded:</span>
                                                    </div>
                                                    <div>
                                                        <div className="mt-3 text-center grey-text">
                                                            <span>Uploaded Files</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            {
                                                                task.files.split("||").map((t, i) => <a
                                                                    rel="noopener noreferrer"
                                                                    href={window.baseAPI + "/file/download?link=" + t + "&token=" + this.props.token}
                                                                    target="_blank" className="d-block mt-1" key={i}>
                                                                    <span>{summarizeString(t.split("/")[t.split("/").length - 1], 25)}</span>
                                                                    <span className="ml-2 green-text">Download</span>
                                                                </a>)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div>
                                                    <div className="border-bottom mt-2 mb-2 pb-2"/>
                                                    <div><span
                                                        className="bold">Solution files:</span>
                                                    </div>
                                                    {task.answerFiles !== '' && <div>
                                                        <div className="mt-3 text-center grey-text">
                                                            <span>Uploaded Files</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            {
                                                                task.answerFiles.split("||").map((t, i) => <a
                                                                    rel="noopener noreferrer"
                                                                    href={window.baseAPI + "/file/download?link=" + t + "&token=" + this.props.token}
                                                                    target="_blank" className="d-block mt-1" key={i}>
                                                                    <span>{summarizeString(t.split("/")[t.split("/").length - 1], 25)}</span>
                                                                    <span className="ml-2 green-text">Download</span>
                                                                </a>)
                                                            }
                                                        </div>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>)
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        tutorEnv: state.param[Objects.tutorEnv],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tasks)
